import React from "react";
import { Box, Skeleton, Typography, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const TruckCardSkeleton = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: 3,
        boxShadow: 3,
        mt: 2,
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.palette.background.main,
      }}
    >
      {/* Image Skeleton */}
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          width: "100%",
          height: { xs: 220, sm: 250, md: 280 },
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      />

      <Box sx={{ px: 2, py: 1 }}>
        {/* Title */}
        <Skeleton width="70%" height={28} sx={{ mb: 1 }} />

        {/* Chip and Rating */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            gap: 1,
            flexWrap: "wrap",
            mb: 1,
          }}
        >
          <Skeleton width={120} height={24} />
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton width={40} height={20} sx={{ ml: 1 }} />
          </Box>
        </Box>

        {/* Description */}
        <Skeleton height={18} width="100%" />
        <Skeleton height={18} width="90%" />
      </Box>

      {/* Meal Tags */}
      <Box sx={{ px: 2, pb: 2 }}>
        <Skeleton width={80} height={20} sx={{ mb: 1 }} />
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          <Skeleton variant="rounded" width={60} height={24} />
          <Skeleton variant="rounded" width={60} height={24} />
          <Skeleton variant="rounded" width={40} height={24} />
        </Box>
      </Box>

      {/* Button */}
      <Box sx={{ px: 2, pb: 2 }}>
        <Skeleton variant="rectangular" height={36} width="100%" sx={{ borderRadius: 2 }} />
      </Box>
    </Box>
  );
};

export default TruckCardSkeleton;
